<div id="map-container-{{id}}" class="map-container new">
  <div class="map-buttons-container" style="top: 168px">
    @if (goToMyLocationBtn) {
      <button class="map-button relative" (click)="goToMyLocation()">
        <q-svg-wrapper iconPath="project-icons/my-location"></q-svg-wrapper>
      </button>
    }
    @if (showLayersButton()) {
      <button class="map-button relative" (click)="toggleMagStyle()">
        <svg class="pointer" viewBox="0 0 24 24" width="20" height="20">
          <use xlink:href="assets/map-icons/layers.svg#c"></use>
        </svg>
      </button>
    }
    @if (showNavigateToObjectButton) {
      <button class="map-button relative" (click)="navigateToObject.emit()">
        <q-svg-wrapper iconPath="project-icons/location"></q-svg-wrapper>
      </button>
    }
  </div>
</div>
